import RestaurantPage, { RestaurantPageProps } from './RestaurantPage';
import withInteractor from './RestaurantPage.interactor';
import withPresenter from './RestaurantPage.presenter';
  
export type { RestaurantPageProps };
export default withInteractor(withPresenter(RestaurantPage));